export const initializeState = ({ data }) => {
  try {
    return { menu: data };
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`initializeState: ${e}`);
  }
  return undefined;
};
